export enum IdlocaGeneric {
    name = "name",
    rating = "rating",
    address = "address",
    project_name = "project_name",
    filter_button = "filter_button",
    reset_button = "reset_button",
    results = "results",
    maker = "maker",
    model = "model",
    type = "type",
    year = "year",
    engine_size = "engine_size",
    select_option = "select_option",
    start_typing = "start_typing",
    no_data = "no_data",
    catalogue = "catalogue",
    buy_motorcycles = "buy_motorcycles",
    buy_parts = "buy_parts",
    reviews = "reviews",
    moto_garages = "moto_garages",
    no_garage_details = "no_garage_details",
    go_to_garages = "go_to_garages",
    contact = "contact",
    working_hours = "working_hours",
    monday = "monday",
    tuesday = "tuesday",
    wednesday = "wednesday",
    thursday = "thursday",
    friday = "friday",
    saturday = "saturday",
    sunday = "sunday",
    closed = "closed",
    gearbox = "gearbox",
    topSpeed = "topSpeed",
    coolingSystem = "coolingSystem",
    language = "language",
    min_cc = "min_cc",
    max_cc = "max_cc",
    year_from = "year_from",
    year_to = "year_to",
    year_range = "year_range",
    maker_name = "maker_name",
    model_name = "model_name",
    type_name = "type_name",
    bore_x_stroke = "bore_x_stroke",
    category = "category",
    clutch = "clutch",
    compression = "compression",
    cooling_system = "cooling_system",
    diameter = "diameter",
    displacement = "displacement",
    dry_weight = "dry_weight",
    engine_type = "engine_type",
    fork_tube_size = "fork_tube_size",
    front_brakes = "front_brakes",
    front_suspension = "front_suspension",
    front_tire = "front_tire",
    front_wheel_travel = "front_wheel_travel",
    fuel_capacity = "fuel_capacity",
    fuel_consumption = "fuel_consumption",
    fuel_control = "fuel_control",
    fuel_system = "fuel_system",
    ground_clearance = "ground_clearance",
    lubrication_system = "lubrication_system",
    oil_capacity = "oil_capacity",
    output = "output",
    overall_height = "overall_height",
    overall_length = "overall_length",
    overall_width = "overall_width",
    power = "power",
    power_output = "power_output",
    power_weight_ratio = "power_weight_ratio",
    rake_fork_angle = "rake_fork_angle",
    rear_brakes = "rear_brakes",
    rear_suspension = "rear_suspension",
    rear_tire = "rear_tire",
    rear_wheel_travel = "rear_wheel_travel",
    reserve_fuel_capacity = "reserve_fuel_capacity",
    seat = "seat",
    seat_height = "seat_height",
    starter = "starter",
    top_speed = "top_speed",
    torque = "torque",
    transmission_type = "transmission_type",
    type_of_engine = "type_of_engine",
    valves_per_cylinder = "valves_per_cylinder",
    wheelbase = "wheelbase",
    back = "back",
    authorization = "authorization",
    vehicle = "vehicle",
    login = "login",
    logout = "logout",
    favourites = "favourites",
    no_favourites = "no_favourites",
    no_compare_list = "no_compare_list",
    go_to_catalogue = "go_to_catalogue",
    cancel = "cancel",
    login_with_facebook = "login_with_facebook",
    find_us_on_facebook = "find_us_on_facebook",
    add_to_favourites = "add_to_favourites",
    remove_from_favourites = "remove_from_favourites",
    view_details = "view_details",
    view_compare_list = "view_compare_list",
    add_to_compare_list = "add_to_compare_list",
    remove_from_compare_list = "remove_from_compare_list",
    item_added_to_compare_list = "item_added_to_compare_list",
    item_removed_from_compare_list = "item_removed_from_compare_list",
    item_added_to_favourites = "item_added_to_favourites",
    item_removed_from_favourites = "item_removed_from_favourites",
    grid = "grid",
    list = "list",
    page_not_found = "page_not_found",
    collapse_filters = "collapse_filters",
    expand_filters = "expand_filters",
    no_filters_applied = "no_filters_applied",
    reset = "reset",
    filter = "filter",
    filter_by_type = "filter_by_type",
    filter_by_city = "filter_by_city",
    website = "website",
    google_maps = "google_maps",
    city = "city",
    tbilisi = "tbilisi",
    kutaisi = "kutaisi",
    batumi = "batumi",
    rustavi = "rustavi",
    zugdidi = "zugdidi",
    poti = "poti",
    gori = "gori",
    telavi = "telavi",
    akhaltsikhe = "akhaltsikhe",
    ozurgeti = "ozurgeti",
    borjomi = "borjomi",
    service = "service",
    store = "store",
    school = "school",
    rent = "rent",
    filters = "filters"
}
